import { AppLayout } from '@/layouts/AppLayout/AppLayout'
import { useGoogleConnectedStatus } from 'containers/deal-sync/hooks/connect-gmail'
import { DealSyncSideBarModalConnected } from 'containers/deal-sync/SbModalConnected'
import { LOCAL_STORAGE_KEY_GOOGLE } from 'containers/deal-sync/types/deal-sync'
import { useMixPanelTracker } from 'containers/mixpanel/hooks/useMixPanelTracker'
import { useUser } from 'containers/user/hooks/useUser'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useProfile } from '../../hooks/useProfile'
import { ProfileMetaData, getProfileMetaData } from '../../utilities/profile'
import { CoverProfile } from './CoverProfile'
import { ProfileBar } from './ProfileBar'

interface ProfileBaseLayoutProps {
  children?: React.ReactNode
  metaProps?: ProfileMetaData
  isProfileBarVisible?: boolean
}

const ProfileBaseLayout = ({
  children,
  metaProps,
  isProfileBarVisible = true, // TODO: JOXXE - update logic for pages without profile bar
}: ProfileBaseLayoutProps) => {
  const {
    profile,
    // isLoading,
    // isError,
    // isFetched
  } = useProfile()
  const { user, refetch, status, isLoading } = useUser()
  const [isModalConnectedOpen, setIsModalConnectedOpen] = useState(false)
  const { data } = useGoogleConnectedStatus()
  const isGoogleConnected = data?.gmailConnected

  useEffect(() => {
    if (status === 'success' && !isLoading && !user?.id) {
      refetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const pageMeta = metaProps || (profile ? getProfileMetaData(profile) : {})
  const { track } = useMixPanelTracker()
  const router = useRouter()

  useEffect(() => {
    // listen to route change
    const handleRouteChange = async () => {
      await track()
    }

    handleRouteChange()

    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events, track])

  useEffect(() => {
    const wasConnecting = localStorage.getItem(LOCAL_STORAGE_KEY_GOOGLE)
    console.log('wasConnecting', wasConnecting)
    if (wasConnecting && isGoogleConnected) {
      setIsModalConnectedOpen(true)
      localStorage.removeItem(LOCAL_STORAGE_KEY_GOOGLE)
    }
  }, [isGoogleConnected])

  // TODO: joxxe - investigate why isLoading = false and profile = null and then profile apears
  // useEffect(() => {
  //   if (isError || (!isLoading && !profile)) {
  //     router.push('/404')
  //   }
  // }, [isError, isLoading, profile, router])

  return (
    <AppLayout {...pageMeta}>
      <>
        <DealSyncSideBarModalConnected
          isOpen={isModalConnectedOpen}
          onClose={() => setIsModalConnectedOpen(false)}
        />
        {isProfileBarVisible && (
          <>
            <div className="relative z-1">
              <CoverProfile />
            </div>
            <div className="relative z-2">
              <div className="">
                <ProfileBar />
              </div>
            </div>
          </>
        )}
        <div>{children}</div>
      </>
    </AppLayout>
  )
}

export { ProfileBaseLayout }
